import {Router} from 'ninelines-router';
import {showHome, showArticle} from './animations';

let router = new Router();

router.addRoute({
	path: '/',
	name: 'home',
	onEnter() {
		return showHome();
	},
});

router.addRoute({
	path: '/article/:id',
	name: 'article',
	onEnter(prevState, currentState) {
		return showArticle(currentState.params.id);
	},
});

router.on('notFound', () => {
	document.location = '/';
});

router.on('leave', () => {
	$(document).trigger('router-leave');
});

router.start();

// eslint-disable-next-line no-underscore-dangle
window._router = router;

export default router;
